import styled from 'styled-components'
import { InputLogin } from '../../components/Input/Input.style'
import { colors } from '../../theme'

export const Title = styled.div`
  font-family: 'Sora';
  font-size: 32px;
  line-height: 150%;
  font-weight: 600;
  margin-bottom: 40px;
`
export const Wrapper = styled.div`
  width: 14.4vw;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.42);
  border-radius: 24px;
  padding: 20px;
  background-color: ${colors.surface};
  @media screen and (max-width: 2100px) {
    width: 16.5vw;
  }
  @media screen and (min-width: 1600px) and (max-width: 2080px) {
    width: 20vw;
  }
  @media screen and (min-width: 1300px) and (max-width: 1550px) {
    width: 26vw;
  }
  @media screen and (min-width: 1000px) and (max-width: 1299px) {
    width: 25vw;
  }
  @media screen and (min-width: 500px) and (max-width: 999px) {
    width: 29.5vw;
  }
  @media screen and (min-width: 300px) and (max-width: 499px) {
    width: 100vw;
  }
`

export const InputStyle = styled.input<{
  border: string
  sizeY: string
  sizeX: string
}>`
  border: 1.5px solid ${({ border }) => border};
  border-radius: 8px;
  width: ${({ sizeX }) => sizeX};
  height: ${({ sizeY }) => sizeY};
  font-size: 13px;
  text-align: center;
  padding-top: 2px;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`

export const InputStyleCalendar = styled(InputLogin)<{
  border: string
  sizeY: string
  sizeX: string
}>`
  border: 1.5px solid ${({ border }) => border};
  border-radius: 12px;
  width: ${({ sizeX }) => sizeX};
  height: ${({ sizeY }) => sizeY};
  font-size: 14px;
  font-weight: 400;
  padding-left: 20px;
  padding-right: 15px;
  color: ${colors.grey600};
`

export const ContainerInput = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`

export const ContainerSearch = styled.div`
  padding: 8px 20px;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  margin-bottom: 15px;
  background-color: ${colors.surface};
`

export const DivInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  height: 55px;
  gap: 15px;
`
export const Search = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  font-size: 14px;
`

export const DivInputMarcarTodos = styled.div`
  display: flex;
  align-items: start;
  justify-content: left;
  width: 170px;
  margin-bottom: 5px;
`
export const DivInputMarcarTodosItenPagina = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
  margin: 10px 0px 10px 20px;
`
export const SpanSearch = styled.div`
  position: absolute;
  top: 28px;
  right: 10px;
  border: none;
  cursor: pointer;
`

// A lupa fica SOBRE o campo de busca, entao nao pode ter fundo proprio: qualquer
// cor solida vira um retangulo visivel dentro do input. No tema claro isso passava
// despercebido porque a cor era a mesma do input (branco); com o campo em fundo
// escuro a diferenca aparece. O mesmo Span existe em mais 8 telas (CriarPedido,
// TabelaVendas, HistoricoBaixa, Mapas, Organizacoes, Sales, Users, UsersAdm) e
// todos foram para `transparent`.
export const Span = styled.div`
  position: absolute;
  top: 24px;
  right: 10px;
  border: none;
  cursor: pointer;
  background-color: transparent;
`

export const SpanCalendar = styled.div`
  background-color: ${colors.surfaceHigh};
  width: 36px;
  height: 36px;
  border-radius: 5px;
  padding: 8px 3px 0px 8px;
  border: none;
  cursor: pointer;
  margin-top: 5px;
`

export const DivCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  background: ${colors.grey100};
`

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
`
export const DivNomePercentual = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  height: 70px;
`

export const Container = styled.div`
  min-height: 190px;
  background-color: ${colors.grey50};
  border-radius: 16px;
  padding: 8px;
`
export const Table = styled.table`
  text-align: center;
  background-color: ${colors.grey50};
  position: relative;
  border: 0;
  padding: 0;
  border-spacing: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
  white-space: normal;
  width: 100%;
  border-spacing: 0;
  border-radius: 10px;
  overflow: hidden;

  tr td {
    padding: 5px;
  }
  td,
  th {
    padding: 5px;
    border-bottom: 6px solid ${colors.surface};
  }
  thead {
    color: ${colors.azul2};
    font-weight: 400;
    text-align: center;
    font-size: 12px;
  }

  tbody {
    font-weight: 400;
    text-align: center;
    font-size: 11px;

    tr {
      td:nth-child(1) {
        text-align: left;
      }
    }
  }

  tr {
    th:nth-child(1) {
      text-align: left;
    }
  }

  tbody > tr:nth-child(odd),
  th > th:nth-child(odd) {
    background-color: ${colors.grey100};
  }
`

/*
 * Barra de filtros: UMA linha so, com tudo dentro — os 7 botoes de filtro, Limpar, Gerar PDF e o
 * periodo. Cada um e um item direto deste flex, entao eles fluem e vao descendo de linha conforme a
 * largura aperta, em vez de um grupo inteiro cair de uma vez (era o que acontecia quando os botoes
 * viviam num `DivInput`, as acoes noutro e o periodo numa linha separada).
 *
 * Tambem e a ancora dos paineis de filtro (todos filhos deste elemento), dai o `position: relative`:
 * como a linha quebra, os paineis nao podem ter `top`/`left` fixos em pixel — descolariam dos
 * botoes. Abrem sempre logo abaixo da barra inteira.
 */
export const Filtros = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 10px;
  position: relative;
  padding: 8px 0;
`

export const FilterDate = styled.div`
  display: flex;
  justify-content: left;
  gap: 20px;
  align-items: center;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 700px;
  top: 225px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 20px;
  width: 500px;
  z-index: 10;
`

export const Calendars = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  font-size: 13px;
  width: 100%;
`

export const DatePickerStyle = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 13px;
  gap: 5px;
`

export const FiltersCalendar = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  background: none;
  border: none;
  height: 100%;
  width: 100%;
`

export const Filters = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  background: none;
  border: none;
  height: 100%;
  width: 100px;
  cursor: pointer;
`
export const Export = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: none;
  border: none;
  height: 100%;
  width: 120px;
  cursor: pointer;
`
export const TypesFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 6px;
  height: 42px;
  font-size: 12px;
  background: ${colors.grey200};
  border-radius: 8px;
`
/* Item da mesma barra dos filtros: largura preferida, mas encolhe ate caber quando a linha aperta. */
export const TypesFilterCalendar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  font-size: 12px;
  height: 42px;
  background: ${colors.grey200};
  border-radius: 8px;
  cursor: pointer;
  width: auto;
  max-width: 100%;
`

export const FilterClient = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(350px, 100%);
  z-index: 10;
`
export const FilterSalesPeople = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(350px, 100%);
  z-index: 10;
`

export const FilterCompanie = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(350px, 100%);
  z-index: 10;
`
export const FilterStatus = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(200px, 100%);
  z-index: 10;
`

export const FilterProduct = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(350px, 100%);
  z-index: 10;
`

/* Segmento e Categoria sao o 6o e o 7o filtros da barra; um pouco mais estreitos que os demais. */
export const FilterSegmento = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(320px, 100%);
  z-index: 10;
`

export const FilterCategoria = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: min(320px, 100%);
  z-index: 10;
`

export const OptionActive = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`

export const Option = styled.div`
  height: 30px;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${colors.grey900};
  font-weight: 500;
  font-size: 12px;
  line-height: 2em;
  text-align: left;
  margin-right: 15px;
  margin-top: 5px;
  border-radius: 4px;
  background-color: ${colors.grey100};
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.6);

  strong {
    font-size: 12px;
    color: ${colors.azul2};
  }
`

export const ButtonClosedOption = styled.button`
  background: ${colors.grey200};
  border: none;
  margin-top: 6px;
  cursor: pointer;
`
export const Filtro = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

export const LinkDownload = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
  font-size: 26px;
  color: ${colors.grey500};
  margin-right: 15px;
  border: none;
  padding-top: 1px;
  cursor: pointer;

  :hover {
    cursor: pointer;
    color: ${colors.help};
  }
`

export const Label = styled.label`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.5px;
  color: ${colors.grey900};
`
export const ContainerModalSend = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 10%;
  background-color: ${colors.overlay};
  display: block;
  z-index: 2;
`

export const SendStyle = styled.div`
  width: 520px;
  padding-top: 10px;
  background-color: ${colors.surface};
  border-radius: 26px 26px 24px 24px;
  margin: 0 auto;
  text-align: center;
  height: 225px;
`
export const Closed = styled.div`
  color: ${colors.errorText};
  font-size: 14px;
  cursor: pointer;
`
export const DivChecked = styled.div`
  border-radius: 24px 24px 0 0;
  padding: 10px 20px 0px 25px;
  margin-bottom: 15px;
  margin-top: 10px;
`
// Texto de confirmacao do modal de baixa em massa: ocupa a largura do card e
// centraliza, ao contrario do DivInputMarcarTodos (170px fixos, para checkbox).
export const TextoConfirmacao = styled.p`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.3px;
  color: ${colors.grey900};
  text-align: center;
  margin: 0;
  padding: 0 20px;
`
